import endpoint from "@sportdevs/endpoint";
import config from "@web/data/config.json";
import { cache } from "react";

const coverageProtocol = config.COVERAGE.PROTOCOL;
const coverageDomain = config.COVERAGE.DOMAIN;

export type CountableType =
  | "categories"
  | "events"
  | "leagues"
  | "players"
  | "teams"
  | "seasons"
  | "live-events";

export const countableTypes = [
  "categories",
  "events",
  "leagues",
  "players",
  "teams",
  "seasons",
  "live-events",
] as readonly CountableType[];

export type Tables =
  | "countries"
  | "odds-total-cards-over-under-movements"
  | "odds-match-handicap"
  | "odds-goals-handicap-movements"
  | "players_shot_actions"
  | "geolocations"
  | "seasons-groups"
  | "odds-asian-handicaps"
  | "seasons_groups"
  | "odds-half-time-full-time"
  | "odds-spread-movements"
  | "events"
  | "odds-odd-even-movements"
  | "events_managers"
  | "odds-draw-no-bet-movements"
  | "odds-half-time-full-time-movements"
  | "leagues-info-promotions"
  | "events-point-by-points"
  | "seasons"
  | "players_heatmaps"
  | "events-weather"
  | "odds-asian-handicap-cards"
  | "odds-total-points-movements"
  | "odds-to-qualify"
  | "leagues-info-largest-stadium"
  | "events-scores-innings-sum"
  | "money"
  | "odds-correct-score"
  | "odds-asian-handicaps-movements"
  | "odds-totals-movements"
  | "unique_tournaments"
  | "news-events"
  | "odds-sets-points-handicap-movements"
  | "unique_tournaments_info"
  | "odds-asian-handicap-corners"
  | "odds-total-points"
  | "cuptrees"
  | "odds_over_under"
  | "odds-over-under"
  | "odds-clean-sheet"
  | "news-players"
  | "odds-own-goal"
  | "leagues-info-official-organisation"
  | "odds-tied-at-end-of-regulation"
  | "teams-seasons"
  | "events-coverage"
  | "odds-home-draw-away-movements"
  | "odds-draw-no-bet"
  | "odds-total-goals-movements"
  | "odds-european-handicap"
  | "odds-full-time-result-movements"
  | "players-cricket-info"
  | "odds-home-draw-away"
  | "teams-leagues"
  | "news-leagues"
  | "odds-european-handicap-movements"
  | "odds-to-win-both-halves-movements"
  | "leagues"
  | "odds-moneyline-movements"
  | "teams_seasons"
  | "teams-statistics"
  | "odds-total-sets-games-movements"
  | "events-powers"
  | "events-scores-innings"
  | "odds-over-under-movements"
  | "media-players"
  | "odds-full-time-results"
  | "teams_players_info"
  | "seasons-info"
  | "players"
  | "odds-to-score-a-penalty"
  | "events-players-shotmap"
  | "odds-both-teams-to-score-movements"
  | "odds-three-way-moneyline-movements"
  | "odds-to-score-in-both-halves-movements"
  | "medias"
  | "odds-three-way-moneyline"
  | "players-statistics"
  | "player-projections"
  | "player-projections-season"
  | "player-projections-week"
  | "events-players-statistics"
  | "odds-match-winner"
  | "players-transfers"
  | "odds-asian-handicap-corners-movements"
  | "odds-both-teams-to-score"
  | "events-managers"
  | "leagues-info-tv-partners"
  | "odds-home-away-movements"
  | "odds-odd-even"
  | "tournaments"
  | "seasons-rounds"
  | "odds-total-sets-games"
  | "odds-own-goal-movements"
  | "teams-players-info"
  | "odds-to-score-in-both-halves"
  | "odds-to-win-to-nil"
  | "teams"
  | "odds-first-team-to-score"
  | "odds-corners-odd-even-movements"
  | "standings"
  | "bookmakers"
  | "odds-goals-handicap"
  | "odds-to-qualify-movements"
  | "odds-clean-sheet-movements"
  | "events-highlights"
  | "odds-sets-points-handicap"
  | "managers"
  | "odds-next-goal-movements"
  | "seasons_info"
  | "odds-home-away"
  | "events-scores"
  | "odds-total-corners-over-under"
  | "events-statistics"
  | "events-live"
  | "odds-corners-odd-or-even"
  | "odds-to-score-penalty-movements"
  | "odds-double-chance"
  | "players_transfers"
  | "odds-spread"
  | "odds-to-win-both-halves"
  | "referees"
  | "leagues-info-last-season-attendance"
  | "managers-career"
  | "venues"
  | "seasons_rounds"
  | "media-leagues"
  | "odds-to-win-from-behind"
  | "media-teams"
  | "odds-total-goals"
  | "players-shot-actions"
  | "odds-sets-points-total-movements"
  | "odds-total-cards-over-under"
  | "teams_unique_tournaments"
  | "players-heatmaps"
  | "events-graphs"
  | "odds-asian-handicap-cards-movements"
  | "news-teams"
  | "leagues-info-last-season-top-scorers"
  | "odds-match-winner-movements"
  | "categories"
  | "odds-total-corners-over-under-movements"
  | "odds-correct-score-movements"
  | "odds-sets-points-total"
  | "odds-to-win-to-nil-movements"
  | "events-innings"
  | "odds-tied-at-end-of-regulation-movements"
  | "leagues-info"
  | "odds-moneyline"
  | "events-players-heatmaps"
  | "odds-next-goal"
  | "odds-double-chance-movements"
  | "odds-totals"
  | "events-incidents"
  | "odds-to-win-from-behind-movements"
  | "events-lineups"
  | "odds-match-handicap-movements"
  | "odds-first-team-to-score-movements";

export const tables = [
  "countries",
  "odds-total-cards-over-under-movements",
  "odds-match-handicap",
  "odds-goals-handicap-movements",
  "players_shot_actions",
  "geolocations",
  "seasons-groups",
  "odds-asian-handicaps",
  "seasons_groups",
  "odds-half-time-full-time",
  "odds-spread-movements",
  "events",
  "odds-odd-even-movements",
  "events_managers",
  "odds-draw-no-bet-movements",
  "odds-half-time-full-time-movements",
  "leagues-info-promotions",
  "events-point-by-points",
  "seasons",
  "players_heatmaps",
  "events-weather",
  "odds-asian-handicap-cards",
  "odds-total-points-movements",
  "odds-to-qualify",
  "leagues-info-largest-stadium",
  "events-scores-innings-sum",
  "money",
  "odds-correct-score",
  "odds-asian-handicaps-movements",
  "odds-totals-movements",
  "unique_tournaments",
  "news-events",
  "odds-sets-points-handicap-movements",
  "unique_tournaments_info",
  "odds-asian-handicap-corners",
  "odds-total-points",
  "cuptrees",
  "odds_over_under",
  "odds-over-under",
  "odds-clean-sheet",
  "news-players",
  "odds-own-goal",
  "leagues-info-official-organisation",
  "odds-tied-at-end-of-regulation",
  "teams-seasons",
  "events-coverage",
  "odds-home-draw-away-movements",
  "odds-draw-no-bet",
  "odds-total-goals-movements",
  "odds-european-handicap",
  "odds-full-time-result-movements",
  "players-cricket-info",
  "odds-home-draw-away",
  "teams-leagues",
  "news-leagues",
  "odds-european-handicap-movements",
  "odds-to-win-both-halves-movements",
  "leagues",
  "odds-moneyline-movements",
  "teams_seasons",
  "teams-statistics",
  "odds-total-sets-games-movements",
  "events-powers",
  "events-scores-innings",
  "odds-over-under-movements",
  "media-players",
  "odds-full-time-results",
  "teams_players_info",
  "seasons-info",
  "players",
  "odds-to-score-a-penalty",
  "events-players-shotmap",
  "odds-both-teams-to-score-movements",
  "odds-three-way-moneyline-movements",
  "odds-to-score-in-both-halves-movements",
  "medias",
  "odds-three-way-moneyline",
  "players-statistics",
  "player-projections",
  "player-projections-season",
  "player-projections-week",
  "events-players-statistics",
  "odds-match-winner",
  "players-transfers",
  "odds-asian-handicap-corners-movements",
  "odds-both-teams-to-score",
  "events-managers",
  "leagues-info-tv-partners",
  "odds-home-away-movements",
  "odds-odd-even",
  "tournaments",
  "seasons-rounds",
  "odds-total-sets-games",
  "odds-own-goal-movements",
  "teams-players-info",
  "odds-to-score-in-both-halves",
  "odds-to-win-to-nil",
  "teams",
  "odds-first-team-to-score",
  "odds-corners-odd-even-movements",
  "standings",
  "bookmakers",
  "odds-goals-handicap",
  "odds-to-qualify-movements",
  "odds-clean-sheet-movements",
  "events-highlights",
  "odds-sets-points-handicap",
  "managers",
  "odds-next-goal-movements",
  "seasons_info",
  "odds-home-away",
  "events-scores",
  "odds-total-corners-over-under",
  "events-statistics",
  "events-live",
  "odds-corners-odd-or-even",
  "odds-to-score-penalty-movements",
  "odds-double-chance",
  "players_transfers",
  "odds-spread",
  "odds-to-win-both-halves",
  "referees",
  "leagues-info-last-season-attendance",
  "managers-career",
  "venues",
  "seasons_rounds",
  "media-leagues",
  "odds-to-win-from-behind",
  "media-teams",
  "odds-total-goals",
  "players-shot-actions",
  "odds-sets-points-total-movements",
  "odds-total-cards-over-under",
  "teams_unique_tournaments",
  "players-heatmaps",
  "events-graphs",
  "odds-asian-handicap-cards-movements",
  "news-teams",
  "leagues-info-last-season-top-scorers",
  "odds-match-winner-movements",
  "categories",
  "odds-total-corners-over-under-movements",
  "odds-correct-score-movements",
  "odds-sets-points-total",
  "odds-to-win-to-nil-movements",
  "events-innings",
  "odds-tied-at-end-of-regulation-movements",
  "leagues-info",
  "odds-moneyline",
  "events-players-heatmaps",
  "odds-next-goal",
  "odds-double-chance-movements",
  "odds-totals",
  "events-incidents",
  "odds-to-win-from-behind-movements",
  "events-lineups",
  "odds-match-handicap-movements",
  "odds-first-team-to-score-movements",
] as readonly Tables[];

export type Sports =
  | "football"
  | "basketball"
  | "tennis"
  | "table-tennis"
  | "hockey"
  | "esports"
  | "handball"
  | "volleyball"
  | "baseball"
  | "american-football"
  | "rugby"
  | "darts"
  | "cricket"
  | "snooker"
  | "futsal"
  | "badminton"
  | "aussie-rules"
  | "beach-volleyball"
  | "waterpolo"
  | "floorball"
  | "bandy"
  | "sport-detect";

export const sports: Sports[] = [
  "football",
  "basketball",
  "tennis",
  "table-tennis",
  "hockey",
  "esports",
  "handball",
  "volleyball",
  "baseball",
  "american-football",
  "rugby",
  "darts",
  "cricket",
  "snooker",
  "futsal",
  "badminton",
  "aussie-rules",
  "beach-volleyball",
  "waterpolo",
  "floorball",
  "bandy",
];

type FetchOptions =
  | Partial<{ method: string; unauthorized: boolean }>
  | undefined;

type ApiErrorBody =
  | {
      code?: string;
      error?: string;
      message?: string;
      [key: string]: unknown;
    }
  | string
  | null
  | undefined;

export class ApiRequestError extends Error {
  status: number;
  statusText: string;
  endpoint: string;
  method: string;
  contentType?: string;
  body?: ApiErrorBody;
  code?: string;

  constructor({
    status,
    statusText,
    endpoint,
    method,
    contentType,
    body,
    code,
    message,
  }: {
    status: number;
    statusText: string;
    endpoint: string;
    method: string;
    contentType?: string;
    body?: ApiErrorBody;
    code?: string;
    message: string;
  }) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.statusText = statusText;
    this.endpoint = endpoint;
    this.method = method;
    this.contentType = contentType;
    this.body = body;
    this.code = code;
  }
}

function normalizeErrorText(value: string, limit = 180) {
  const compact = value.replace(/\s+/g, " ").trim();
  if (!compact) {
    return "";
  }
  return compact.length > limit ? `${compact.slice(0, limit)}...` : compact;
}

function isHtmlLike(value: string) {
  const normalized = value.trimStart().toLowerCase();
  return (
    normalized.startsWith("<!doctype") ||
    normalized.startsWith("<html") ||
    normalized.includes("<body") ||
    normalized.includes("</html>")
  );
}

function extractApiErrorMessage(
  method: string,
  endpoint: string,
  status: number,
  statusText: string,
  body?: ApiErrorBody,
) {
  const prefix = `${method} ${endpoint} failed with ${status} ${statusText}`;

  if (typeof body === "string") {
    const normalized = normalizeErrorText(body);
    if (!normalized || isHtmlLike(normalized)) {
      return prefix;
    }
    return `${prefix}: ${normalized}`;
  }

  if (body && typeof body === "object") {
    const candidate =
      (typeof body.message === "string" && body.message) ||
      (typeof body.error === "string" && body.error) ||
      undefined;

    if (candidate) {
      return `${prefix}: ${normalizeErrorText(candidate)}`;
    }
  }

  return prefix;
}

export function preformRequest(
  path: string,
  extra: FetchOptions,
  authToken: string | undefined,
) {
  return fetch(path, {
    method: extra?.method,
    next: {
      revalidate: 300,
    },
    headers: {
      ...(authToken
        ? {
            authorization: "Bearer " + authToken,
          }
        : {}),
    },
  })
    .then(async (x) => {
      if (x.status !== 200) {
        throw { status: x.status, statusText: x.statusText };
      }
      try {
        const response = await x.json();
        const paginationCount =
          x.headers.get("X-Pagination-Count") ?? undefined;
        const paginationLimit =
          x.headers.get("X-Pagination-Limit") ?? undefined;

        const hasPagination = !!(paginationCount && paginationLimit);

        return {
          content: response,
          pagination: hasPagination
            ? {
                count: Number(paginationCount),
                limit: Number(paginationLimit),
              }
            : undefined,
        };
      } catch {
        return {
          content: await x.text(),
        };
      }
    })
    .catch((err) => {
      throw err;
    });
}

export const emptyCounts = {
  categories: 0,
  events: 0,
  leagues: 0,
  players: 0,
  seasons: 0,
  teams: 0,
  football_live_events: 0,
  basketball_live_events: 0,
  tennis_live_events: 0,
  table_tennis_live_events: 0,
  ice_hockey_live_events: 0,
  esports_live_events: 0,
  handball_live_events: 0,
  volleyball_live_events: 0,
  baseball_live_events: 0,
  american_football_live_events: 0,
  rugby_live_events: 0,
  darts_live_events: 0,
  cricket_live_events: 0,
  snooker_live_events: 0,
  futsal_live_events: 0,
  badminton_live_events: 0,
  aussie_rules_live_events: 0,
  beach_volley_live_events: 0,
  waterpolo_live_events: 0,
  floorball_live_events: 0,
  bandy_live_events: 0,
};

export type Counts = typeof emptyCounts;

export async function getCounts() {
  return (
    await preformRequest(
      `${coverageProtocol}://sport-detect.${coverageDomain}/counts`,
      {},
      undefined,
    )
  ).content[0] as Counts;
}

export function createService(service: string) {
  let authToken: undefined | string = undefined;
  return {
    authenticate: (key: string) => (authToken = key),
    request: (path: string, extra: FetchOptions = {}) =>
      preformRequest(
        `${coverageProtocol}://${service}.${coverageDomain}/${path}`,
        extra,
        authToken,
      ),
  };
}

export const services = {
  metadata: createService("sport-detect"),
  football: createService("football"),
  basketball: createService("basketball"),
  tennis: createService("tennis"),
  "table-tennis": createService("table-tennis"),
  hockey: createService("hockey"),
  esports: createService("esports"),
  handball: createService("handball"),
  volleyball: createService("volleyball"),
  baseball: createService("baseball"),
  "american-football": createService("american-football"),
  rugby: createService("rugby"),
  darts: createService("darts"),
  cricket: createService("cricket"),
  snooker: createService("snooker"),
  futsal: createService("futsal"),
  badminton: createService("badminton"),
  "aussie-rules": createService("aussie-rules"),
  "beach-volleyball": createService("beach-volleyball"),
  waterpolo: createService("waterpolo"),
  floorball: createService("floorball"),
  bandy: createService("bandy"),
  "sport-detect": createService("sport-detect"),
};

const Unauthorized = { unauthorized: true };

type Endpoints = {
  [key in Tables]: () => ReturnType<typeof endpoint>;
};

export const objectRequest = (
  input: Awaited<ReturnType<typeof makeApiRequest>>,
) => {
  const response = input;
  if (typeof response !== "object")
    throw new TypeError("makeApiRequest() did not return an object");
  return response;
};

export const makeApiRequest = (
  method: string,
  endpoint: string,
  token?: string,
  body?: any,
) => {
  return fetch(`${config.API_URL}${endpoint}`, {
    cache: "no-store",
    next: {
      revalidate: 0,
    },
    method: method,
    headers: {
      ...(token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {}),
      ...(body
        ? {
            "Content-Type": "application/json",
          }
        : {}),
    },
    ...(body
      ? {
          body: JSON.stringify(body),
        }
      : {}),
  }).then(async (response) => {
    if (response.status === 404) {
      return {
        content: null,
      };
    }
    if (!response.ok) {
      const contentType = response.headers.get("content-type") ?? undefined;
      let body: ApiErrorBody;

      try {
        if (contentType?.startsWith("application/json")) {
          body = (await response.json()) as ApiErrorBody;
        } else {
          body = await response.text();
        }
      } catch {
        body = undefined;
      }

      const code =
        body && typeof body === "object" && typeof body.code === "string"
          ? body.code
          : undefined;

      throw new ApiRequestError({
        status: response.status,
        statusText: response.statusText,
        endpoint,
        method,
        contentType,
        body,
        code,
        message: extractApiErrorMessage(
          method,
          endpoint,
          response.status,
          response.statusText,
          body,
        ),
      });
    }
    if (response.headers.get("content-type")?.startsWith("application/json")) {
      const paginationCount =
        response.headers.get("X-Pagination-Count") ?? undefined;
      const paginationLimit =
        response.headers.get("X-Pagination-Limit") ?? undefined;

      const hasPagination = !!(paginationCount && paginationLimit);

      return {
        content: await response.json(),
        pagination: hasPagination
          ? {
              count: Number(paginationCount),
              limit: Number(paginationLimit),
            }
          : undefined,
      };
    }
    return response.text();
  });
};

const endpoints = Object.fromEntries(
  tables.map((table) => [table, () => endpoint(table)]),
) as Endpoints;

function createPublicEndpoints(sport: Sports) {
  return {
    leagues: () => endpoint(`${sport}-leagues`),
    teams: () => endpoint(`${sport}-teams`),
    categories: () => endpoint(`${sport}-categories`),
    seasons: () => endpoint(`${sport}-seasons`),
    planCounts: () => endpoint(`${sport}-plan-counts`),
  };
}
const bookmakers_endpoint = () => endpoint(`bookmakers`);

export const getData = cache(
  <T>(
    sport: Sports,
    selector: (e: Endpoints) => ReturnType<typeof endpoint>,
  ) => {
    const ep = selector({ ...endpoints });
    return services[sport].request(ep.toString()) as Promise<{
      content: T[];
      metadata?: {
        range: {
          start: number;
          end: number;
          length?: number;
        };
      };
    }>;
  },
);

export const getPublicData = cache(
  (
    sport: Sports,
    selector: (
      e: ReturnType<typeof createPublicEndpoints>,
    ) => ReturnType<typeof endpoint>,
  ) => {
    const ep = selector(createPublicEndpoints(sport));
    return services.metadata.request(ep.toString(), Unauthorized) as Promise<{
      content: any[];
      pagination?: {
        count: number;
        limit: number;
      };
    }>;
  },
);

export const getBookmakers = cache(
  (
    selector: (e: ReturnType<typeof endpoint>) => ReturnType<typeof endpoint>,
  ) => {
    const ep = selector(bookmakers_endpoint());
    return services.metadata.request(ep.toString(), Unauthorized) as Promise<{
      content: any[];
      metadata?: {
        range: {
          start: number;
          end: number;
          length?: number;
        };
      };
    }>;
  },
);

export type EventSourceEndpoints =
  | "score"
  | "time"
  | "graph"
  | "incident"
  | "statistics"
  | "innings"
  | "point-by-points"
  | "odds"
  | "live-count";
